/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShipSearchQuerystringGet200ResponseRecordsInner } from './ShipSearchQuerystringGet200ResponseRecordsInner';
import {
    ShipSearchQuerystringGet200ResponseRecordsInnerFromJSON,
    ShipSearchQuerystringGet200ResponseRecordsInnerFromJSONTyped,
    ShipSearchQuerystringGet200ResponseRecordsInnerToJSON,
} from './ShipSearchQuerystringGet200ResponseRecordsInner';

/**
 * 
 * @export
 * @interface ShipSearchQuerystringGet200Response
 */
export interface ShipSearchQuerystringGet200Response {
    /**
     * 
     * @type {Array<ShipSearchQuerystringGet200ResponseRecordsInner>}
     * @memberof ShipSearchQuerystringGet200Response
     */
    records?: Array<ShipSearchQuerystringGet200ResponseRecordsInner>;
}

/**
 * Check if a given object implements the ShipSearchQuerystringGet200Response interface.
 */
export function instanceOfShipSearchQuerystringGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipSearchQuerystringGet200ResponseFromJSON(json: any): ShipSearchQuerystringGet200Response {
    return ShipSearchQuerystringGet200ResponseFromJSONTyped(json, false);
}

export function ShipSearchQuerystringGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipSearchQuerystringGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(ShipSearchQuerystringGet200ResponseRecordsInnerFromJSON)),
    };
}

export function ShipSearchQuerystringGet200ResponseToJSON(value?: ShipSearchQuerystringGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(ShipSearchQuerystringGet200ResponseRecordsInnerToJSON)),
    };
}

